import React from 'react';
import Create from '../../rest/Create';
import Form from '../components/Form';

const SalaryHistoriesCreate = props => (
  <Create {...props} resource="salaryHistories">
    <Form />
  </Create>
);

SalaryHistoriesCreate.propTypes = {};

export default SalaryHistoriesCreate;
